import { getIBPPLogin } from './ibppIntegration'

const customLoginRoutes = [
  {
    name: 'ibpp',
    path: 'ibpp/:uuid?',
    meta: {
      fn: getIBPPLogin,
      customRegisterRoute: 'RegisterSimpleRegistrationIbpp'
    },
    hasLogo: true,
    image: 'ibpp-logo.png'
  }
]

export default customLoginRoutes
